'use strict';

import angular from 'angular';
import ReportsController from './reports.controller';
import ReportsStudentHoursController from './student-hours/student-hours.controller'
import ReportsTotalHoursController from './total-hours/total-hours.controller'
import ReportsTotalHoursRangeController from './total-hours-range/total-hours-range.controller'
import ReportsTutorCountController from './tutor-count/tutor-count.controller'
import ReportsTutorHoursController from './tutor-hours/tutor-hours.controller'
import ReportsTotalHoursWeekController from './total-hours-week/total-hours-week.controller'
import ReportsStudentOverviewController from './student-overview/student-overview.controller'

export default angular.module('accessApp.reports', ['accessApp.auth', 'ui.router'])
  .config(function routes($stateProvider) {
  	'ngInject';

	$stateProvider.state('reports', {
	    url: '/reports',
	    template: require('./reports.html'),
	    controller: 'ReportsController',
	    controllerAs: 'vm',
       authenticate: true,
  	}).state('reports.studentHrs', {
  		url: '/student-hours',
  		template: require('./student-hours/student-hours.html'),
  		controller: 'ReportsStudentHoursController',
  		controllerAs: 'vm',
       authenticate: true,
  	}).state('reports.tutorHrs', {
      url: '/tutor-hours',
      template: require('./tutor-hours/tutor-hours.html'),
      controller: 'ReportsTutorHoursController',
      controllerAs: 'vm',
       authenticate: true,
    }).state('reports.totalHrs', {
      url: '/total-hours',
      template: require('./total-hours/total-hours.html'),
      controller: 'ReportsTotalHoursController',
      controllerAs: 'vm',
       authenticate: true,
    }).state('reports.totalHrsRange', {
      url: '/total-hours-range',
      template: require('./total-hours-range/total-hours-range.html'),
      controller: 'ReportsTotalHoursRangeController',
      controllerAs: 'vm',
       authenticate: true,
    }).state('reports.totalHrsWeek', {
      url: '/total-hours-week',
      template: require('./total-hours-week/total-hours-week.html'),
      controller: 'ReportsTotalHoursWeekController',
      controllerAs: 'vm',
       authenticate: true,
    }).state('reports.tutorCount', {
      url: '/tutor-count',
      template: require('./tutor-count/tutor-count.html'),
      controller: 'ReportsTutorCountController',
      controllerAs: 'vm',
       authenticate: true,
    })
    .state('reports.studentOverview', {
      url: '/student-overview',
      template: require('./student-overview/student-overview.html'),
      controller: 'ReportsStudentOverviewController',
      controllerAs: 'vm',
       authenticate: true,
    })
  })
  .controller('ReportsController', ReportsController)
  .controller('ReportsStudentHoursController', ReportsStudentHoursController)
  .controller('ReportsTutorCountController', ReportsTutorCountController)
  .controller('ReportsTotalHoursController', ReportsTotalHoursController)
  .controller('ReportsTutorHoursController', ReportsTutorHoursController)
  .controller('ReportsStudentOverviewController', ReportsStudentOverviewController)
  .controller('ReportsTotalHoursWeekController', ReportsTotalHoursWeekController)
  .controller('ReportsTotalHoursRangeController', ReportsTotalHoursRangeController)
  .name;


// WEBPACK FOOTER //
// ./client/app/reports/index.js